'use client';

import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { NavigationMenuItem, NavigationMenuLink } from '@govinity/ui/components/ui/navigation-menu';
import { cn } from '@govinity/ui/lib/utils';
import { type MenuItem as MenuItemType } from '@govinity/ui/components/blocks/navbar/types';

const publicMenuItemClassName =
  'flex items-center space-x-2 font-medium transition-all focus-visible px-3 py-2 rounded-md h-auto';

export const PublicMenuItem = ({ item, className }: { item: MenuItemType; className?: string }) => {
  const pathname = usePathname();

  const isActive = pathname === item.url;

  return (
    <NavigationMenuItem>
      <NavigationMenuLink asChild>
        <Link
          className={cn(
            publicMenuItemClassName,
            isActive
              ? 'bg-white/20 text-white shadow-sm'
              : 'text-white/90 hover:bg-white/10 hover:text-white',
            className
          )}
          href={item.url}
        >
          {!!item.icon && <div className="mr-1">{item.icon}</div>}
          {item.title}
        </Link>
      </NavigationMenuLink>
    </NavigationMenuItem>
  );
};
